export const TOKEN_KEY = 'stwd-community-web/token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setToken = (token: string | null) =>
  token === null
    ? localStorage.removeItem(TOKEN_KEY)
    : localStorage.setItem(TOKEN_KEY, token);

export const IMPERSONATING_KEY = 'stwd-community-web/impersonating';

export const getImpersonating = () => {
  // Read defensively: this runs at reducer module-load time, and accessing
  // localStorage can throw when storage is blocked (private mode, sandboxed
  // iframes, cookies disabled) — which would otherwise crash app bootstrap.
  try {
    return localStorage.getItem(IMPERSONATING_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setImpersonating = (impersonating: boolean) =>
  impersonating
    ? localStorage.setItem(IMPERSONATING_KEY, 'true')
    : localStorage.removeItem(IMPERSONATING_KEY);
